<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>
          Campaigns
        </h1>
      </div>
    </div>
    <div class="container-fluid">

      <div class="dashboard-results-details">
        <div class="w-full flex flex-wrap justify-between spacer-b-2">
          <div class="count"><span>{{ pagination.total }}</span> Campaigns</div>
          <campaign-sort v-model="sort" />
        </div>
      </div>
      <div class="flex w-full spacer-x-3 spacer-y-3 bg-grey-light">
        <input id="search" class="w-full" v-model="search" placeholder="Search campaign title or description" style="border: none; padding-left: 20px;" @keypress.enter="handleGetCampaignsCallback"/>
        <ladda-button class="btn btn-lg btn-primary flex-shrink-0 margin-l-2" :click="handleGetCampaignsCallback">
          Search
        </ladda-button>
      </div>

      <div class="dashboard-block">
        <ul class="nav nav-tabs" role="tablist">
          <li :class="{ 'active': status === 'active' }">
            <router-link :to="{ params: { status: 'active' }, query: $route.query }">Active</router-link>
          </li>
          <li :class="{ 'active': status === 'draft' }">
            <router-link :to="{ params: { status: 'draft' }, query: $route.query }">Drafts</router-link>
          </li>
          <li :class="{ 'active': status === 'archived' }">
            <router-link :to="{ params: { status: 'archived' }, query: $route.query }">Archived</router-link>
          </li>
        </ul>

        <pickstar-loading v-if="fetching" class="m-t-lg"/>

        <template v-else>
          <no-results v-if="!(campaigns && campaigns.length !== 0)">
            <div>There are no campaigns.</div>
          </no-results>

          <ul class="list-items">
            <campaign-list-item  v-for="campaign in campaigns" :key="campaign.id" :campaign="campaign"/>
          </ul>

          <lazy-loading
            class="text-center"
            :loading="loading"
            :reached-bottom="handleGetNextCampaignsCallback"
            ref="lazyLoading">
            <pickstar-loading slot="loading"/>
            <span slot="finished"></span>
          </lazy-loading>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignListItem from './CampaignListItem'
import CampaignSort from './CampaignSort'
import LazyLoading from 'codium-lazy-loading'
import { http } from 'utils'

export default {
  props: {
    status: {
      required: false,
      default: 'active'
    }
  },

  components: {
    CampaignListItem,
    CampaignSort,
    LazyLoading
  },

  data () {
    return {
      fetching: false,
      loading: false,
      campaigns: [],
      pagination: {},
      sort: {
        sort: 'created_at',
        order: 'desc'
      },
      search: ''
    }
  },

  watch: {
    '$route' () {
      this.handleGetCampaignsCallback()
    }
  },

  mounted () {
    this.handleGetCampaignsCallback()
  },

  computed: {
    params () {
      return {
        sort: this.$route.query.sort,
        sort_direction: this.$route.query.order,
        status: this.status,
        keywords: this.search
      }
    }
  },

  methods: {
    handleGetCampaignsCallback () {
      this.fetching = true

      return http.get(`campaigns`, { params: this.params }).then(response => {
        this.campaigns = response.data.data
        this.pagination = response.data.meta
        this.fetching = false
      })
    },

    handleGetNextCampaignsCallback () {
      if (this.pagination && this.pagination.current_page < this.pagination.last_page) {
        this.loading = true
        return http.get(`campaigns`, { params: { ...this.params, page: this.pagination.current_page + 1 } }).then(response => {
          this.campaigns.push(...response.data.data)
          this.pagination = response.data.meta
          this.loading = false
        })
      }
      return Promise.resolve()
    }
  }
}
</script>
